var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 35.4375C27.6305 35.4375 35.4375 27.6305 35.4375 18C35.4375 8.36953 27.6305 0.5625 18 0.5625C8.36953 0.5625 0.5625 8.36953 0.5625 18C0.5625 27.6305 8.36953 35.4375 18 35.4375Z",
    fill: "#FCE2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9934 28.3921C30.3671 26.2148 28.2553 24.4468 25.826 23.2287C23.3967 22.0106 20.7167 21.3759 17.9991 21.375C15.2815 21.3741 12.6011 22.0072 10.1711 23.2238C7.74097 24.4404 5.62814 26.207 4.00049 28.3833C5.61987 30.5706 7.72924 32.3481 10.1595 33.5731C12.5897 34.7981 15.2732 35.4367 17.9947 35.4375C20.7162 35.4384 23.4001 34.8015 25.8311 33.578C28.2621 32.3545 30.3726 30.5784 31.9934 28.3921Z",
    fill: "#772286"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.125C21.7279 19.125 24.75 16.1029 24.75 12.375C24.75 8.64708 21.7279 5.625 18 5.625C14.2721 5.625 11.25 8.64708 11.25 12.375C11.25 16.1029 14.2721 19.125 18 19.125Z",
    fill: "#772286"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser1);
export default __webpack_public_path__ + "static/media/user1.a7ceb98ce364db4a5e10c6769429b7bd.svg";
export { ForwardRef as ReactComponent };